import clsx from 'clsx'
import { Button } from 'primitives/button'
import { Tooltip } from 'primitives/tooltip'
import type { DragEventHandler } from 'react'

import { GripVerticalIcon } from 'lucide-react'
import type { DataTableInstance, DataTableRowData, HTMLPropsRef } from '../../types'

interface Props<TData extends DataTableRowData> {
  actionIconProps?: HTMLPropsRef<HTMLButtonElement>
  onDragEnd: DragEventHandler<HTMLButtonElement>
  onDragStart: DragEventHandler<HTMLButtonElement>
  table: DataTableInstance<TData>
}

export const GrabHandleButton = <TData extends DataTableRowData>({
  actionIconProps,
  onDragEnd,
  onDragStart,
  table: {
    options: {
      localization: { move },
    },
  },
}: Props<TData>) => (
  <Tooltip content={actionIconProps?.title ?? move}>
    <Button
      aria-label={actionIconProps?.title ?? move}
      draggable
      {...actionIconProps}
      className={clsx(
        'cursor-grab active:cursor-grabbing mrt-grab-handle-button h-4 w-4',
        actionIconProps?.className,
      )}
      onClick={(e) => {
        e.stopPropagation()
        actionIconProps?.onClick?.(e)
      }}
      onDragEnd={onDragEnd}
      onDragStart={onDragStart}
      title={undefined}
      variant="ghost"
      size="icon"
    >
      <GripVerticalIcon size="100%" />
    </Button>
  </Tooltip>
)
